import type {FC} from 'react'
import {Blankslate as PrimerBlankslate} from '@primer/react/experimental'
import styles from './Blankslate.module.css'

type BlankslateProps = {
  heading: string
  children?: React.ReactNode
}

export const Blankslate: FC<BlankslateProps> = ({heading, children}) => {
  return (
    <div className={styles.BlankslateContainer}>
      <PrimerBlankslate>
        <PrimerBlankslate.Heading as="h3">{heading}</PrimerBlankslate.Heading>
        {children ? <PrimerBlankslate.Description>{children}</PrimerBlankslate.Description> : null}
      </PrimerBlankslate>
    </div>
  )
}
